var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCloseWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "146px",
    height: "146px",
    viewBox: "0 0 146 146",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / close / white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eat-Local-assets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-close-/-white",
    transform: "translate(-7.000000, -7.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "close-copy",
    transform: "translate(-16.000000, -16.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.7,96 L166.9,30.8 C168.5,29.2 168.5,26.7 166.9,25.1 C165.3,23.5 162.8,23.5 161.2,25.1 L96,90.3 L30.8,25.2 C29.2,23.6 26.7,23.6 25.1,25.2 C23.5,26.8 23.5,29.3 25.1,30.9 L90.3,96 L25.1,161.2 C23.5,162.8 23.5,165.3 25.1,166.9 C26,167.6 27,168 28,168 C29,168 30,167.6 30.8,166.8 L96,101.7 L161.2,166.9 C162,167.7 163,168.1 164,168.1 C165,168.1 166,167.7 166.8,166.9 C168.4,165.3 168.4,162.8 166.8,161.2 L101.7,96 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 0,
    y: 0,
    width: 192,
    height: 192
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseWhite);
export default __webpack_public_path__ + "static/media/icon-close-white.9bab8923d4dd4002cfd9da3f5fdedd1b.svg";
export { ForwardRef as ReactComponent };